// extracted by mini-css-extract-plugin
export default {"heroContainer":"PageHero_heroContainer__iDt0Q","profileImage":"PageHero_profileImage__4+Tdi","introduction":"PageHero_introduction__zc7ch"};